import { render, staticRenderFns } from "./NotificationPane.vue?vue&type=template&id=07334a52&scoped=true"
import script from "./NotificationPane.vue?vue&type=script&lang=js"
export * from "./NotificationPane.vue?vue&type=script&lang=js"
import style0 from "./NotificationPane.vue?vue&type=style&index=0&id=07334a52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07334a52",
  null
  
)

export default component.exports